// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledWrapper, StyledRow, StyledText, StyledNumber } from './OrdersSummaryStyles';
import { getFormattedNumber } from '@/utils';

type TOrdersSummary = {
  count?: number;
  totalSum?: number;
};

const OrdersSummary = ({ count, totalSum }: TOrdersSummary) => {
  const { t } = useTranslation(['orders']);

  if (!totalSum) return null;

  return (
    <StyledWrapper>
      <StyledRow>
        <StyledText>{t('orders_amount')}:</StyledText>
        <StyledNumber>{count}</StyledNumber>
      </StyledRow>
      <StyledRow>
        <StyledText>{t('orders_payed')}:</StyledText>
        <StyledNumber>{getFormattedNumber(totalSum)} ₴</StyledNumber>
      </StyledRow>
    </StyledWrapper>
  );
};

export default OrdersSummary;
